// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"1acbed62","159":"86fe5a49","216":"490edaee","239":"2f822dd7","396":"4bbffb13","455":"ef4bc2c9","530":"6c8eb036","699":"4abdb413","970":"596fadf2","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};